import { render, staticRenderFns } from "./OrderPackageDetailModal.vue?vue&type=template&id=343a42cb&"
import script from "./OrderPackageDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderPackageDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackageDetailModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports